"use client";

import React from "react";
import TrackedLink from "./TrackedLink"; // Import TrackedLink

interface FullHeightImageProps {
  imageSrc: string;
  heading: string;
  subheading: string;
  text: string;
  buttonText: string;
  buttonLink: string;
  brochureLink?: string;
  divHeight?: string;
  imagePosition?: "left" | "right";
  imgClassName?: string;
  headingLevel?: "h1" | "h2" | "h3";
}

const FullHeightImage: React.FC<FullHeightImageProps> = ({
  imageSrc,
  heading,
  subheading,
  text,
  buttonText,
  buttonLink,
  brochureLink,
  divHeight = "md:min-h-[400px]",
  imagePosition = "left",
  imgClassName = "",
  headingLevel = "h1",
}) => {
  const Heading = headingLevel;
  return (
    <div
      className={`relative flex flex-col md:flex-row ${divHeight} rounded-lg overflow-hidden my-10`}
    >
      {/* Image */}
      <div
        className={`relative flex-1 ${
          imagePosition === "right" ? "md:order-2" : ""
        }`}
      >
        <img
          src={imageSrc}
          alt={heading}
          style={{ objectFit: "cover", width: "100%", height: "100%" }}
          className={`${imgClassName}`}
        />
      </div>

      {/* Text Content */}
      <div
        className={`relative z-10 flex-1 flex flex-col justify-center p-6 bg-[var(--color-bg-muted)] ${
          imagePosition === "right" ? "md:pl-6" : "md:pr-6"
        }`}
      >
        <Heading className="text-xl md:text-3xl font-bold text-[var(--color-text-brand)]">{heading}</Heading>

        {brochureLink && (
        <div className="mt-4">
        <TrackedLink
            href={brochureLink}
            newTab
            label="FullHeightImage > Download Brochure"
            component="FullHeightImage"
            color="neutral"
            variant="outline"
            size="md"
            >
            Download Brochure
          </TrackedLink>
          </div>
        )}
        {subheading && (
          <h2 className="text-lg md:text-xl text-[var(--color-text-brand)] mt-2">{subheading}</h2>
        )}
        {typeof text === "string" ? (
          <div
            className="text-[var(--color-text-secondary)] mt-4"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <div className="text-white mt-4">{text}</div>
        )}
        {buttonText && buttonLink && (
          <div className="flex justify-start my-5">
            <TrackedLink
              href={buttonLink}
              label="FullHeightImage > Button Click"
              component="FullHeightImage"
              color="neutral"
              variant="outline"
              size="md"
             >
              {buttonText}
            </TrackedLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default FullHeightImage;